import { inject, Provider } from '@angular/core';

import { Cb2PreviewStateService } from '@core/services/cb2-preview/cb2-preview-state.service';

import {
  KIOSK_PRODUCT_ADD_PAGE_DATA_SOURCE,
  KioskProductAddPageDataSource,
} from './kiosk-product-add-page-view-model';
import { KioskProductAddPagePreviewDataSource } from './kiosk-product-add-page-preview-data-source';
import { KioskProductAddPageStoreDataSource } from './kiosk-product-add-page-store-data-source';

export function provideKioskProductAddPageDataSource(): Provider[] {
  return [
    KioskProductAddPageStoreDataSource,
    KioskProductAddPagePreviewDataSource,
    {
      provide: KIOSK_PRODUCT_ADD_PAGE_DATA_SOURCE,
      useFactory: (): KioskProductAddPageDataSource => {
        const previewState = inject(Cb2PreviewStateService);
        return previewState.isActive()
          ? inject(KioskProductAddPagePreviewDataSource)
          : inject(KioskProductAddPageStoreDataSource);
      },
    },
  ];
}
